import React from "react";

import Zar8YieldPositionContent from "../../components/Zar8YieldPositionContent";
import Header from "../../layouts/Header";

export default function Zar8TrackPosition() {
  return (
    <div className="min-h-screen bg-[#F8F8F8]">
      <Header />
      <Zar8YieldPositionContent />
    </div>
  );
}
